/**
 * Checks if a string is valid http url
 * @param {string} string - string to be validated
 * @returns boolean
 */
export const isValidHttpUrl = string => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export default isValidHttpUrl;
